import React from "react";
import { PAYMENT_META } from "../../utils/constants";
import { formatMoney } from "../../utils/format";
import { calculateBalance } from "../../utils/jobOrderForm";

/* Step 3 — price, advance, live balance and payment terms. */
export default function StepPricing({ form, update, currencies, paymentMethods, active }) {
  return (
    <div className={`wizard-step-panel ${active ? "active" : ""}`} id="step-panel-3">
      <div className="panel-section-title">
        <span className="section-badge">3</span> Price and Payment Terms
      </div>

      <div className="form-grid grid-3">
        <div className="form-group">
          <label htmlFor="input-currency">Currency</label>
          <select id="input-currency" value={form.currency} onChange={(e) => update({ currency: e.target.value })}>
            {currencies.map((currency) => (
              <option key={currency.short_form} value={currency.short_form}>
                {currency.short_form === currency.name ? currency.short_form : `${currency.short_form} (${currency.name})`}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="input-total_price">
            Price / Amount <span className="req">*</span>
          </label>
          <input
            type="number"
            id="input-total_price"
            step="0.01"
            min="0"
            placeholder="0.00"
            value={form.total_price}
            onChange={(e) => update({ total_price: e.target.value })}
          />
        </div>
        <div className="form-group">
          <label htmlFor="input-advance_paid">Advance Paid</label>
          <input
            type="number"
            id="input-advance_paid"
            step="0.01"
            min="0"
            placeholder="0.00"
            value={form.advance_paid}
            onChange={(e) => update({ advance_paid: e.target.value })}
          />
        </div>
      </div>

      <div className="balance-display-box">
        <div className="balance-title">Calculated Outstanding Balance</div>
        <div className="balance-amount">{formatMoney(calculateBalance(form), form.currency)}</div>
      </div>

      <div className="form-group">
        <label className="section-sublabel">Payment Method:</label>
        <div className="radio-options-grid">
          {paymentMethods.map((method) => (
            <label className="radio-card" key={method}>
              <input
                type="radio"
                name="payment_method"
                value={method}
                checked={form.payment_method === method}
                onChange={() => update({ payment_method: method })}
              />
              <span className="radio-content">{PAYMENT_META[method]?.option || method}</span>
            </label>
          ))}
        </div>
        {form.payment_method === "other" && (
          <div className="form-group mt-2">
            <input
              type="text"
              id="input-payment_other"
              placeholder="Specify payment details"
              maxLength={255}
              value={form.payment_other}
              onChange={(e) => update({ payment_other: e.target.value })}
            />
          </div>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="input-special_instructions">Special Instructions</label>
        <textarea
          id="input-special_instructions"
          rows="3"
          placeholder="Enter special delivery instructions, invoice notes, or client references"
          value={form.special_instructions}
          onChange={(e) => update({ special_instructions: e.target.value })}
        ></textarea>
      </div>
    </div>
  );
}
